/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Widgets (`blue-300`) overlaid with MaterialRounded Add Circle (`grey-500`).
 * @export
 */
export const ICON_WIDGETS_WITH_ADD_CIRCLE = (
  <svg fill="none" height="177" viewBox="0 0 176 177" width="176" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 88.5C0 39.8989 39.3989 0.5 88 0.5C136.601 0.5 176 39.8989 176 88.5V144.5C176 162.173 161.673 176.5 144 176.5H88C39.3989 176.5 0 137.101 0 88.5Z"
      fill="white"
    />
    <g clipPath="url(#clip0_293_20280)">
      <path
        d="M93 98.5V128.5C93 131.25 95.25 133.5 98 133.5H128C130.75 133.5 133 131.25 133 128.5V98.5C133 95.75 130.75 93.5 128 93.5H98C95.25 93.5 93 95.75 93 98.5ZM48 133.5H78C80.75 133.5 83 131.25 83 128.5V98.5C83 95.75 80.75 93.5 78 93.5H48C45.25 93.5 43 95.75 43 98.5V128.5C43 131.25 45.25 133.5 48 133.5ZM43 48.5V78.5C43 81.25 45.25 83.5 48 83.5H78C80.75 83.5 83 81.25 83 78.5V48.5C83 45.75 80.75 43.5 78 43.5H48C45.25 43.5 43 45.75 43 48.5ZM107.75 40.5L86.5 61.7C84.55 63.65 84.55 66.8 86.5 68.75L107.75 90C109.7 91.95 112.85 91.95 114.8 90L136.05 68.75C138 66.8 138 63.65 136.05 61.7L114.85 40.5C112.9 38.55 109.7 38.55 107.75 40.5Z"
        fill="#0774D2"
      />
    </g>
    <circle cx="131" cy="131.5" fill="white" r="29" />
    <path
      clipRule="evenodd"
      d="M106.833 131.5C106.833 118.16 117.66 107.333 131 107.333C144.34 107.333 155.167 118.16 155.167 131.5C155.167 144.84 144.34 155.667 131 155.667C117.66 155.667 106.833 144.84 106.833 131.5ZM133.417 133.917H140.667C141.996 133.917 143.083 132.829 143.083 131.5C143.083 130.171 141.996 129.083 140.667 129.083H133.417V121.833C133.417 120.504 132.329 119.417 131 119.417C129.671 119.417 128.583 120.504 128.583 121.833V129.083H121.333C120.004 129.083 118.917 130.171 118.917 131.5C118.917 132.829 120.004 133.917 121.333 133.917H128.583V141.167C128.583 142.496 129.671 143.583 131 143.583C132.329 143.583 133.417 142.496 133.417 141.167V133.917Z"
      fill="#949494"
      fillRule="evenodd"
    />
    <defs>
      <clipPath id="clip0_293_20280">
        <rect fill="white" height="120" transform="translate(28 28.5)" width="120" />
      </clipPath>
    </defs>
  </svg>
);
